<template>
  <div class="movie">
    <van-list
      v-model="loading"
      :offset="500"
      :finished="finished"
      :immediate-check="false"
      :finished-text="showAdv ? '后续内容更加精彩！' : '~ 完 ~'"
      @load="getMovieList(2)"
    >
      <div
        class="w-100"
        :style="'background-color: '+(light?'#e5e5e5':'#111')"
        v-for="(item,index) in list"
        :key="index"
      >
        <img
          v-if="!showAdv && isOnePage&&index===0"
          class="w-100"
          src="https://cdn-yp.yymedias.com/public/img/icon/demo.png"
          alt
          @click="openImg"
        />
        <div
          v-if="!showAdv && isOnePage&&index===0"
          class="p-50 fz-42"
          :style="'color: '+(light?'#333':'#777')"
        >
          好电影与世界分享！本图解由
          <img
            class="logo"
            src="https://cdn-yp.yymedias.com/public/img/logo/80.png"
            alt
          />
          APP 荣誉出品，未经授权，不得转载。
        </div>
        <a  v-if="item.adv" :href="item.adv_url" @click="advClick(item.adv)"
          :data-clipboard-text="item.adv.copy? getAdvCopy(item.adv.copy) : ''" 
          :class="item.adv.market ? 'acopy' : ''" >
          <img class="w-100" :src="item.url" alt @click="openImg" />
          <div
            class="p-50 fz-42"
            :style="'color: '+(light?'#333':'#777')"
          >{{item.reading}}</div>
        </a>
        <template v-else>
          <img class="w-100" :src="item.url+(isSupportWebp?'!webp':'!yy')" alt @click="openImg"/>
          <div
            class="p-50 fz-42"
            :style="'color: '+(light?'#333':'#777')"
            v-if="item.reading!=''"
          >{{item.reading}}</div>
        </template>
      </div>
    </van-list>
    <div v-if="finished && showAdv" style="padding:0 .4rem 1.6rem .4rem">
      <yd-button size="large" style="margin-top:0;" @click.native="onClickPageBtn" type="primary" bgcolor="#f4e60b" shape="circle">点我继续观看 \(^o^)/~</yd-button>
    </div>
    <div class="model-box dp-f" v-show="showModel">
      <div class="pop-box">
        <img class="mt32 p-32" style="width:100%" :src="icon.down"/>
        <div class="w-100 dp-f fz-32" style="flex-direction:column;min-height:60px;line-height: 2em;text-align: center;" v-if="ispayMovie">
          <!-- <div class="payinfo">
            限时<span class="youhuijia">9.<span>9</span></span>元<span class="yuanjia"> (原价：12.9)</span>看完整版！
          </div> -->
          <div class="payinfo" v-html="txt.info"></div>
          <div>后续内容更加精彩！</div>
          <div v-if="isPay">如您已支付，请勿重新支付！！！</div>
        </div>
        <div class="w-100 dp-f fz-32" style="min-height:60px;line-height: 2em;text-align: center;" v-else>
          {{txt.info}}<br />请下载『有影APP』观看完整版。
        </div>
        <div
          class="copy p-50 dp-f"
          :data-clipboard-text="'￠' + clipboardText + '￠'"
          @click="onClickDialogBtn"
        >
          <div class="look">{{txt.btn}}</div>
        </div>
        <div v-if="isPay"
          class="copy dp-f" style="padding-bottom:25px;"
          @click="payOk"
        >
          <div class="look">我已支付</div>
        </div>
      </div>
      <a
              target="_blank"
              @click="showModel=false"
              v-if="!isOnePage"
              style="position:absolute;bottom:1rem; left:40%;width:20%;text-align: center;">
        <yd-icon name="error-outline" color="#fff"></yd-icon>
      </a>
    </div>
    <van-popup
      v-model="popShow"
      position="left"
      style="width:70%;max-width:400px;height:100%;background-color: #222"
    >
      <div class="left-box">
        <div
          class="chapter-list"
          v-for="(chapter,num) in chapterList"
          :key="num"
          :class="chapter.id===chapter_id?'chapter-click':(chapter_id===0&&num===0?'chapter-click':'')"
          @click="optChapter(chapter,num)"
        >
          <div class="dp-f w-100 h-100">{{chapter.name}}</div>
          <div class="line"></div>
        </div>
      </div>
      <div class="caozuo">
        <div class="dp-fc" @click="changeLight">
          <img v-if="light" class="img" :src="icon.night" />
          <img v-else class="img" :src="icon.light" />
          <div
            class="mt10"
            style="font-size:0.3rem;color:#999"
          >{{light?'夜间模式':'白昼模式'}}</div>
        </div>
        <div class="dp-fc copy" :data-clipboard-text="'￠' + clipboardText + '￠'" @click="downLoad">
          <img class="img" :src="icon.more" />
          <div class="mt10" style="font-size:0.3rem;color:#999">更多电影</div>
        </div>
      </div>
    </van-popup>
    <van-popup :transition="'fade'" v-model="pageLoading" style="width: 100%;height:100%">
      <div class="pageinit">
        <img class="caozuo-btn" :src="icon.load" />
        <div
          class="mt32 p-32 text-oh"
          style="font-size:0.32rem;font-weight:bold;color:#e5e5e5"
        >{{isOnePage?txtArr[code]:chapterName}}</div>
      </div>
    </van-popup>
    <img v-if="!pageLoading" class="chapter-btn" :src="icon.menu" @click="showPopup" />
    <a
      :href="'/sp/1/' + expand"
      target="_blank"
      @click="spm(1203, movies_id)"
      v-if="!isOnePage && showAdv && !ispayMovie"
      class="more-info"
    >
      <img src="https://cdn-yp.yymedias.com/public/APP/img/h5/detail/more1.png" />
<!--    <a-->
<!--        href="https://engine.lvehaisen.com/index/activity?appKey=24rtSWo7G7TSZFncTUUrY4j9xhZe&adslotId=342125"-->
<!--        target="_blank"-->
<!--        @click="spm(1203, movies_id)"-->
<!--        v-if="true || !isOnePage"-->
<!--        class="more-info"-->
<!--    >-->
<!--      <img src="https://yun.tuitiger.com/mami-media/img/wmckjno0mh.gif"/>-->
    </a>
    <div class="pt-f bg-0-7" v-show="showOpenBrowser">
      <div class="p-all-32 pt-a br-10 bg-b color-fff fz-32" style="top:5px;right:5px">
        <div>请点击右上角的"..."</div>
        <div>选择用"Safari"浏览器打开</div>
      </div>
    </div>
  </div>
</template>

<script>
import { List } from 'vant'
import Clipboard from 'clipboard'
import { fetch, post } from '@/api/request.js'
import { setTimeout } from 'timers';
const conf = { shenma: { code: 'nW5rhQ', channelId: '1' } }
import Hashids from 'hashids'
const hashids = new Hashids('bQE4zm7TJ3I7Bl4v')
export default {
  name: "Movies",
  data() {
    return {
      ispayMovie: false,
      isPay: false,
      expand: '',
      channelId: '0', // 渠道ID
      showOpenBrowser: false,
      showAdv: true,
      light: true,//白天/黑夜
      downurl: '',
      downidconfig: '10101,10102,10103',
      clipboardText: '',
      list: [],
      txt: {
        info: '后续更精彩！',
        btn: '继续观看'
      },
      icon: {
        light: 'https://cdn-yp.yymedias.com/public/APP/img/h5/detail/day.png',
        night: 'https://cdn-yp.yymedias.com/public/APP/img/h5/detail/night.png',
        more: 'https://cdn-yp.yymedias.com/public/APP/img/h5/detail/more.png',
        load: 'https://cdn-yp.yymedias.com/public/APP/img/h5/detail/loading.gif',
        menu: 'https://cdn-yp.yymedias.com/public/APP/img/h5/detail/menu.png',
        down: 'https://cdn-yp.yymedias.com/public/APP/img/h5/detail/alert.png'
      },
      loading: false,
      finished: false,
      next_id: 0,
      chapter_id: 0,
      movies_id: 0,
      isOnePage: true,
      isSupportWebp: false,
      showModel: false,
      popShow: false,
      pageLoading: true,
      chapterList: [],//章节列表
      timeOutId: 0,
      chapterName: '',
      txtArr: [
        '精彩电影，即将呈现...',
        'The wonderful film is about to appear...',
        'สุดยอดภาพยนตร์ที่กำลังจะแสดง . . . . . . .',
        '映画が素晴らしい映画に、まもなく…',
        ' فيلم رائع  ،  سوف  تظهر  .',
        'Super film, sera présente.',
        '재미있는 영화, 곧 나타나다...'
      ],
      code: 0,
    }
  },
  components: {
    [List.name]: List
  },
  mounted() {
    // const payMovieIds = ['1129', '2908', '3234', '1141', '3215'];
    // if (payMovieIds.indexOf(this.$route.params.id) !== -1) {
      // this.ispayMovie = true;
    // }
    this.ispayMovie = true;
    
    this.pageLoading = true
    this.next_id = this.$route.params.id
    this.movies_id = this.$route.params.id
    this.localKey = 'Trade_' + this.movies_id;
    let rss = this.$route.params.rid
    if (conf[rss]) {
      this.clipboardText = conf[rss].code;
      this.expand = conf[rss].code;
      this.channelId = conf[rss].channelId;
    } else {
      const code = hashids.decode(rss)
      if (code.constructor === Array) {
        if (code[1] == 1) { // 外推ID
          this.clipboardText = rss;
          this.expand = rss;
          this.channelId = code[0];
        }
        if (rss == '8lYoIw') {
          this.showAdv = false;
        }
      }
    }

    if (this.clipboardText != '') {
      let code1 = hashids.decode(this.clipboardText)
      if (code1.constructor === Array) {
        if (!code1[2]) {
          code1.push(parseInt(this.movies_id));
          console.log(code1);
          this.clipboardText = hashids.encode(code1);
        }
      }
    }

    this.isSupportWebp = !![].map && document.createElement('canvas').toDataURL('image/webp').indexOf('data:image/webp') == 0;
    //判断设备
    let ua = window.navigator.userAgent.toLowerCase();
    if (ua.indexOf("iphone") !== -1 || ua.indexOf("ipad") !== -1 || ua.indexOf("mac") !== -1) {//ios
      this.downurl = 'itms-apps://apps.apple.com/cn/app/id1367366681'
      if (ua.match(/WeiBo/i) == "weibo") {
        //在新浪微博客户端打开
        this.downurl = ''
      }
    } else if (ua.indexOf("android") !== -1) {//安卓
      this.downurl = 'market://details?id=com.yymedias'
    } else {
      this.downurl = "https://appstore.huawei.com/app/C100396523"
    }
    //微信浏览器
    if (ua.match(/MicroMessenger/i) == 'micromessenger') {
      this.downurl = "https://a.app.qq.com/o/simple.jsp?pkgname=com.yymedias"
    }

    window.addEventListener('scroll', this.onScroll, true); // 监听（绑定）滚轮滚动事件
    this.spm(1200, this.movies_id)
    this.initData()
  },
  watch: {
    light(val) {
      if (val) {
        document.body.style.backgroundColor = "#fff";
      } else {
        document.body.style.backgroundColor = "#000";
      }
    },
    showModel(val){
      if (val) {
        this.spm(1204, this.movies_id)
      } else {
        this.spm(1205, this.movies_id)
      }
    }
  },
  methods: {
    getAdvCopy(txt){
      if (txt != '') {
        let code1 = hashids.decode(txt)
        if (code1.constructor === Array) {
          if (!code1[2]) {
            code1.push(parseInt(this.movies_id));
            txt = hashids.encode(code1);
          }
        }
      }
      return '￠' + txt + '￠';
    },
    advClick(adv) {
      this.spm(1206, adv.id + '.' + this.movies_id);
      if (adv.market) {
        let clipboard = new Clipboard('.acopy')
        clipboard.on('success', e => {
          // 释放内存
          clipboard.destroy()
        })
        clipboard.on('error', e => {
          // 释放内存
          clipboard.destroy()
        })
        if (this.downurl) {
          this.$dialog.loading.open('正在打开...');
          setTimeout(()=>{
            window.location.href = this.downurl;
          }, 50);
          setTimeout(()=>{
            this.$dialog.loading.close();
          }, 1000);
        } else {
          this.showOpenBrowser = true
        }
      }
    },
    initData() {
      this.play()
      let chapter = new Promise((resolve, reject) => {
        fetch('chapters', { movies_id: this.movies_id }).then((res) => {
          if (res.status_code == 200) {
            let data = JSON.parse(decodeURIComponent(res.data))
            this.chapterList = data
            resolve()
          } else {
            reject('请求失败')
          }
        }).catch((err) => {
          reject(err)
        })
      })
      let movies = new Promise((resolve, reject) => {
        fetch('get_movie', { movies_id: this.next_id }).then((res) => {
          console.log('get_movie ok', res);
          if (res.status_code == 200) {
            let data = JSON.parse(decodeURIComponent(res.data))
            if (data.movies.name) {
              document.title = data.movies.name
            }
            this.next_id = data.next_id
            this.list = data.images;
            // const adv = {
            //   reading: '',
            //   url: 'https://yun.tuitiger.com/mami-media/img/dbihn2veqo.jpg',
            //   adv: 1,
            //   adv_url: 'https://engine.lvehaisen.com/index/activity?appKey=24rtSWo7G7TSZFncTUUrY4j9xhZe&adslotId=342270'
            // };

            // const adv = {
            //   reading: '',
            //   url: 'https://cdn-yp.yymedias.com/public/3ths/nangua.gif',
            //   adv: {id: 1},
            //   adv_url: 'https://h5.vcinema.cn/h5/partner/receive_down/index.html?type=P070_YOUYING&shop=standard_NaSkp'
            // };
            // this.list.splice(5, 0, adv);

            // const adv2 = {
            //   reading: '好电影与世界分享！本图解由 『有影APP』 荣誉出品，未经授权，不得转载。',
            //   url: 'https://cdn-yp.yymedias.com/public/3ths/nangua.jpg',
            //   adv: {id: 2},
            //   adv_url: 'https://h5.vcinema.cn/h5/partner/receive_down/index.html?type=P070_YOUYING&shop=standard_yxVyg'
            // };
            // this.list.splice(0, 0, adv2);

            // const adv3 = {
            //   reading: '好电影与世界分享！本图解由 『有影APP』 荣誉出品，未经授权，不得转载。',
            //   url: 'https://cdn-yp.yymedias.com/public/3ths/nangua.jpg',
            //   adv: {id: 3},
            //   adv_url: 'https://apph5.yymedias.com/expand/gYQPTO'
            // };
            // this.list.splice(0, 0, adv3);

            
            if (this.showAdv) {
              const adv4 = {
                reading: '好电影与世界分享！本图解由 『有影APP』 荣誉出品，未经授权，不得转载。',
                url: 'https://cdn-yp.yymedias.com/public/3ths/nangua.jpg',
                adv: {id: 4, copy:'V3qpT9', market: true},
                adv_url: 'javascipt:void(0);'
              };
              this.list.splice(0, 0, adv4);
            }
            
            

            // const adv6 = {
            //   reading: '好电影与世界分享！本图解由 『有影APP』 荣誉出品，未经授权，不得转载。',
            //   url: 'https://cdn-yp.yymedias.com/public/3ths/nangua.jpg',
            //   adv: {id: 6},
            //   adv_url : 'https://h5.vcinema.cn/h5/partner/receive_down/index.html?type=P070_YOUYING&shop=standard_NaSkp'
            // }

            // const rand = Math.floor(Math.random() * (100 - 0));
            // if (rand > 50) {
            //   this.list.splice(0, 0, adv4);
            // } else {
            //   this.list.splice(0, 0, adv6);
            // }
            resolve()
          } else {
            reject('请求失败')
          }
        }).catch((err) => {
          reject(err)
        })
      })
      Promise.all([chapter, movies]).then(() => {
        setTimeout(() => {
          this.pageLoading = false
          this.stop()
        }, 1500)
      }).catch(err => {
        this.pageLoading = false
        this.stop()
        this.popShow = false
        this.loading = false
        this.finished = true
        this.showModel = true
        this.txt.info = ''
        // this.txt.btn = ''
        console.log('错误信息',err)
      })

    },
    changeLight() {
      this.popShow = false
      this.light = !this.light
    },
    changeCode() {
      let num = this.txtArr.length - 1
      let code = parseInt(Math.random() * (num + 1), 10)
      if (this.code === code) {
        this.changeCode()
        return
      }
      this.code = code
    },
    play() {
      let _this = this
      this.timeOutId = setInterval(function () {
        _this.changeCode()
      }, 1500)
    },
    stop() {
      clearInterval(this.timeOutId);
    },
    spm(num, id) {
      var img = new Image();
      img.src = 'https://spm.yymedias.com/?from=120.' + this.channelId + '.0.0.' + num + '.' + id;
    },
    openImg() {
      return
    },
    optChapter(item, index) {
      this.chapterName = item.name
      if (index === 0) {
        this.isOnePage = true
      } else {
        this.isOnePage = false
      }
      this.code = 0
      this.next_id = item.id
      this.getMovieList(1)
      this.pageLoading = true
      this.finished = false;
    },
    showPopup() {
      this.popShow = true
    },
    getMovieList(type) {
      if (this.next_id == 0) {
        this.popShow = false
        this.loading = false;
        this.finished = true;
        this.showAdv = false;
        this.showModel = true && this.showAdv;
        return;
      }
      this.spm(1202, this.next_id)
      this.chapter_id = this.next_id
      fetch('get_movie', { chapter_id: this.next_id, password: this.expand, t: localStorage.getItem(this.localKey) }).then((res) => {
        if (res.status_code == 200) {
          let data = JSON.parse(decodeURIComponent(res.data))
          if (data.movies.name) {
            document.title = data.movies.name
          }
          this.next_id = data.next_id
          if (type === 1) {
            this.backTop()
            this.list = data.images
            this.popShow = false
          } else {
            this.isOnePage = false
            this.list = [...this.list, ...data.images];
          }
          // 加载状态结束
          this.loading = false;
        } else if (res.status_code == 201) {
          this.popShow = false
          this.loading = false;
          this.finished = true;
          this.showModel = true
        } else {
          this.popShow = false
          this.loading = false;
          this.finished = true;
          this.showModel = true
          if (this.ispayMovie) {
            this.txt.info = '限时<span class="youhuijia">6.<span>9</span></span>元<span class="yuanjia"> (原价：18.9)</span>看完整版！'
            this.txt.btn = '立即支付';
          }
        }
        setTimeout(() => {
          this.pageLoading = false
        }, 500)
      })
    },
    backTop() {
      document.body.scrollTop = 0
      document.documentElement.scrollTop = 0
    },
    onClickDialogBtn() {
      if (this.ispayMovie) {
        fetch('do_trade', {id: this.movies_id}).then(res => {
          if (res.status_code == 200) {
            let data = JSON.parse(decodeURIComponent(res.data))
            localStorage.setItem(this.localKey, data.trade);
            const url = "https://pay.yymedias.com/alipay/wappay/pay.php?t="+data.trade
            // + "&a=0.01" // 测试金额
            + "&s=" + encodeURIComponent('有影')
            + "&b=" + encodeURIComponent(document.title)
            + '&n=' + encodeURIComponent(location.href);
            location.href = url;
            setTimeout(() => {
              this.txt.btn = '继续支付';
              this.isPay = true;
            }, 1000)
          }
        })
      } else {
        this.downLoad();
      }
    },
    payOk() {
      location.reload();
    },
    onClickPageBtn () {
      this.showModel = true;
    },
    downLoad() {
      this.spm(1201, this.movies_id)
      if (this.clipboardText != '') {
        var clipboard = new Clipboard('.copy')
        clipboard.on('success', e => {
          // 释放内存
          clipboard.destroy()
        })
        clipboard.on('error', e => {
          // 释放内存
          clipboard.destroy()
        })
      }
      if (this.downurl) {
        this.$dialog.loading.open('正在打开...');
        setTimeout(()=>{
          window.location.href = this.downurl;
        }, 50);
        setTimeout(()=>{
          this.$dialog.loading.close();
        }, 1000);
      } else {
        this.showOpenBrowser = true
      }
    },
    onScroll() {
      //   var scrollTop = document.documentElement.scrollTop || document.body.scrollTop || window.pageYOffset
    },
  }
}
</script>

<style scoped>
* {
  -webkit-touch-callout: none;
  -webkit-user-select: none;
  -khtml-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}
.fade-enter,
.fade-enter-active {
  opacity: 1;
}
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
.logo {
  width: 0.5rem;
  height: 0.5rem;
  vertical-align: middle;
  border-radius: 0.1rem;
}
.movie {
  max-width: 13rem;
  margin: 0 auto;
}
.w-100 {
  width: 100%;
  line-height: 0;
}
.h-100 {
  height: 100%;
}
.p-32 {
  padding: 0.32rem;
}
.p-50 {
  padding: 0.5rem;
}
.p-10-0 {
  padding: 0.1rem 0;
  background-color: #000;
}
.mt10 {
  margin-top: 0.1rem;
}
.fz-32 {
  font-size: 0.32rem;
}
.fz-42 {
  line-height: 0.7rem;
  font-size: 0.42rem;
  font-weight: bold;
}
.mt32 {
  margin-top: 0.32rem;
}
.btn {
  width: 100%;
  height: 1.5rem;
  background-color: #e5e5e5;
  cursor: pointer;
}
.dp-f {
  display: flex;
  justify-content: center;
  align-items: center;
}
.dp-fc {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
.dp-fc img {
  width: 40%; height: auto;
  margin: .1rem 0;
}
.chapter-btn {
  z-index: 1001;
  width: 1rem;
  height: 1rem;
  position: fixed;
  bottom: 0.5rem;
  left: 0.5rem;
  cursor: pointer;
}
.btn-night {
  border: 2px solid #999;
  background-color: rgba(0, 0, 0, 0.6);
}
.model-box {
  z-index: 1100;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.7);
}
.pageinit {
  z-index: 1002;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #000;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  opacity: 1;
}
.chapter-list {
  width: 100%;
  margin: 0 auto;
  height: 1rem;
  color: #999;
  font-size: 0.32rem;
  font-weight: 500;
}
.caozuo {
  width: 100%;
  height: 15vh;
  display: flex;
  justify-content: space-around;
  align-items: center;
}

.line {
  width: 80%;
  margin: 0 auto;
  height: 1px;
  background-color: #333;
  transform: scale(100%, 50%);
}
.chapter-click {
  color: #f4e60b;
  font-weight: bold;
}
.pop-box {
  width: 6rem;
  border-radius: 0.5rem;
  background-color: #fff;
  padding: 0 0.32rem;
}
.left-box {
  width: 100%;
  height: 85vh;
  overflow: hidden;
  overflow-x: hidden;
  overflow-y: auto;
}

.left-box::-webkit-scrollbar {
  /*滚动条整体样式*/
  /* display: none; */
  width: 4px; /*高宽分别对应横竖滚动条的尺寸*/
  height: 4px;
}
.left-box::-webkit-scrollbar-thumb {
  /*滚动条里面小方块*/
  border-radius: 5px;
  box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
  background: rgba(255, 255, 255, 0.1);
}
.left-boxx::-webkit-scrollbar-track {
  /*滚动条里面轨道*/
  box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
  border-radius: 0;
  background: rgba(0, 0, 0, 0.1);
}
.look {
  display: inline-block;
  height: 0.8rem;
  line-height: 0.8rem;
  padding: 0 0.5rem;
  font-size: 0.4rem;
  border-radius: 0.4rem;
  background-color: #f4e60b;
}
.caozuo-btn {
  width: 1rem;
  height: 1rem;
  display: inline-block;
  overflow: hidden;
  cursor: pointer;
}
.img {
  width: 1rem;
  height: 1rem;
  -webkit-filter: brightness(180%);
  filter: brightness(180%);
  cursor: pointer;
}

.more-info {
  position: fixed;
  bottom: 2rem;
  right: 0.3rem;
  width: 1.4rem;
  text-align: center;
}
.more-info:before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: url("https://cdn-yp.yymedias.com/public/APP/img/h5/detail/more1-bg.png")
    no-repeat center;
  background-size: 100% 100%;
  z-index: 0;
  animation: mymove 3s infinite;
}
@keyframes mymove {
  0% {
    transform: scale(1) rotate(0deg);
  }
  50% {
    transform: scale(1.4) rotate(180deg);
  }
  100% {
    transform: scale(1) rotate(360deg);
  }
}
.more-info img {
  position: relative;
  width: 100%;
  z-index: 1;
}

</style>
<style>
.youhuijia {
  font-size:1.8em;
  color: #f45888;
}
.youhuijia span {
  font-size: .8em;
}
.yuanjia {
  text-decoration:line-through;
  color: #999;
  font-size: .8em;
}
</style>
